import { type ComponentProps, useId } from 'react';
import { css, ClassNames } from '@emotion/react';
import styled from '@emotion/styled';
import IcCheckCircleBold from 'src/assets/images/icCheckCircleBold.svg';
import IcCheckCircleFill from 'src/assets/images/icCheckCircleFill.svg';
const Container = styled.label`
  display: flex;
  align-items: center;
  gap: 0.5rem;

  font-size: 16px;
  font-weight: 400;

  :has(input:checked) {
    font-weight: 700;
  }
`;
const Input = styled.input`
  display: none;
`;
const Checkbox__Circle = styled.div`
  position: relative;

  width: 1.75rem;
  height: 1.75rem;

  input:disabled ~ & {
    opacity: 0.3;
  }
`;
const iconStyles = css`
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;

  transition: opacity 0.2s ease;
`;
const UncheckedIcon = styled(IcCheckCircleBold)`
  ${iconStyles}

  color: ${({
  theme
}) => theme.color.content5};

  input:checked ~ * > & {
    opacity: 0;
  }
`;
const CheckedIcon = styled(IcCheckCircleFill)`
  ${iconStyles}

  color: ${({
  theme
}) => theme.color.content12};

  input:not(:checked) ~ * > & {
    opacity: 0;
  }
`;
interface props extends Pick<ComponentProps<'input'>, 'name' | 'checked' | 'value' | 'onChange' | 'className' | 'disabled'> {
  label?: string;
}
const LocaleSelect = ({
  name,
  checked,
  value,
  onChange,
  label,
  className,
  disabled
}: props) => {
  const id = useId();
  return <ClassNames data-sentry-element="ClassNames" data-sentry-component="LocaleSelect" data-sentry-source-file="Select.tsx">
      {({
      cx
    }) => <Container htmlFor={id} className={cx(className, checked ? 'checked' : 'not-checked')}>
          <Input type='checkbox' id={id} checked={checked} name={name} value={value} onChange={onChange} disabled={disabled} />
          <Checkbox__Circle>
            <CheckedIcon />
            <UncheckedIcon />
          </Checkbox__Circle>
          <span>{label ?? value}</span>
        </Container>}
    </ClassNames>;
};
export default LocaleSelect;